'use client';

import { useState, useEffect } from 'react';

export function AppVersion() {
  const [version, setVersion] = useState<string>('1.0.0');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Загружаем версию из файла VERSION
    fetch('/VERSION')
      .then((res) => {
        if (res.ok) {
          return res.text();
        }
        throw new Error('Version file not found');
      })
      .then((text) => {
        const v = text.trim();
        if (v) {
          setVersion(v);
        }
      })
      .catch(() => {
        // Если файл не найден, используем версию по умолчанию
        setVersion('1.0.0');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return null;
  }

  return (
    <div className="text-xs text-[#68707D] text-center">
      <div className="font-medium">Версия: {version}</div>
    </div>
  );
}

